import styled from "styled-components"
import { motion } from "framer-motion"

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  margin: 0 auto;
  height: 100vh;

  ${({ theme }) => theme.mq.atTablet`
    flex-direction: row;
  `}
`

export const TextPositioner = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  left: 0;
  top: 0;
  width: 70vw;
  height: 50%;
  z-index: 20;

  ${({ theme }) => theme.mq.atTablet`
    width: 50vw;
    height: 100%;
    margin-left: 20px;

  `}

  & > div {
    margin-top: 20px;

    ${({ theme }) => theme.mq.atTablet`
      align-self: flex-start;

    `}
  }
`

export const DisplayItemPositioner = styled.div`
  position: relative;
  display: flex;
  width: 100vw;
  height: 50%;
  /* right: 0; */
  z-index: 10;
  align-items: center;
  justify-content: center;
  top: 15%;
  padding-bottom: 20%;

  ${({ theme }) => theme.mq.atTablet`
    width: 63vw;
    height: 100%;
    top: 0;
    padding-bottom: 0;

  `}

  & > span {
    top: -32%;
    left: -22%;
  }
`

export const LogoPositioner = styled.div`
  position: absolute;
  width: 100px;
  top: 0;

  ${({ theme }) => theme.mq.atTablet`
     top: auto;

  `}
`

export const SelectorPositioner = styled(motion.div)`
  bottom: 5%;
  left: 0;
  width: 100%;
  z-index: 30;
  margin: 0 auto;
  text-align: center;

  ${({ theme }) => theme.mq.atTablet`
    margin: auto;
    text-align: left;

  `}
`
